<template>
  <div class="content-block">
    <div class="flex-between flex-v-top">
      <div class="content-block-title">{{ $lang.messages.themes.title }} <br>
        <span class="text-muted text-md text-thin">{{ $lang.messages.themes.choose_theme }}</span>
      </div>
      <input ref="file" type="file" accept="image/jpeg, image/png" class="hidden" v-on:change="uploadImage"/>
      <button class="btn btn-outline" v-on:click="selectFile">{{ $lang.messages.themes.upload_image }}</button>
    </div>
    <div class="row" style="position: relative">
      <loading :active=loading :is-full-page="false"></loading>
      <div :key=theme.id v-for="theme in allThemes" class="col-xl-3 col-lg-4 col-sm-6">
        <div class="theme-preview-wrapper" :class="{active: themeCurrent === theme.id}"
             @click="chooseTheme(theme.id, theme.premium)">
          <span v-if="theme.premium && !isPremium" class="ribbon-premium"></span>
          <div class="theme-preview">
            <img :src="imgUrl(theme.src)" alt="theme preview">
          </div>
          <span class="theme-remove-btn" v-show="theme.isUploaded" v-on:click="removeUploaded(theme)">
             <i class="icon-close"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app"
import "firebase/storage"
import defaultThemes from "@/helpers/themes"
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { reportEvent } from "@/helpers/utils"

const images = require.context('../assets/img/themes/', false, /\.jpg$/)

export default {
  name: 'Backgrounds',
  components: {
    Loading,
  },
  props: ['isPremium', 'themeCurrent', 'uploadedThemes'],
  data: function () {
    return {
      themes: defaultThemes,
      loading: false,
    }
  },
  computed: {
    allThemes() {
      return this.themes.concat(this.uploadedThemes || []);
    }
  },
  methods: {
    removeUploaded: async function (theme) {
      try {
        const storage = firebase.storage().ref(theme.path)
        await storage.delete()
      } catch (e) {
        console.warn(e)
      }
      const updated = this.uploadedThemes.filter(function (obj) {
        return obj.id !== theme.id;
      });
      this.chooseTheme(this.themes[0].id);
      this.$emit('updatesettings', {uploadedThemes: updated})
    },
    selectFile: function () {
      if (!this.isPremium) {
        this.$emit('openonlypremiummodal')
        return false
      }

      this.$refs.file.click();
    },
    uploadImage: function (e) {
      const user = firebase.auth().currentUser
      const file = e.target.files[0];
      const storePath = `themes/${user.uid}/${file.name}`;
      const storage = firebase.storage().ref(storePath)
      this.loading = true;
      storage.put(file)
          .then(async () => {
            const url = await storage.getDownloadURL();

            this.uploadedThemes.push({
              id: this.uploadedThemes.length + defaultThemes.length + 1,
              premium: true,
              src: url,
              path: storePath,
              isUploaded: true
            });
            this.$emit('updatesettings', {uploadedThemes: this.uploadedThemes})
            this.loading = false
            reportEvent('uploadCustomBgImage')
          })
          .catch(d => console.log(d))
    },
    imgUrl: function (path) {
      if (path.includes('https')) {
        return path;
      }
      return images('./' + path)
    },
    updateSettings(keyName, value) {
      this.$emit('updatesettings', {[keyName]: value})
    },
    chooseTheme(id, premium) {
      if (premium && !this.isPremium) {
        this.$emit('openonlypremiummodal')
        return false
      }
      this.updateSettings('theme', id)
    },
    openMenuItem(title) {
      this.$emit('openmenuitem', title);
    }
  }
}
</script>

<style lang="scss">
@import "../assets/styles/icons";

.hidden {
  display: none;
}

.theme-preview {
  position: relative;
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s;
  margin-bottom: 8px;

  &-wrapper {
    position: relative;
    padding: 2px;
    overflow: hidden;

    &.active .theme-preview:after,
    &:hover .theme-preview:after {
      opacity: 1;
      visibility: visible;
    }

    &.active {
      &:before {
        content: "\e901";
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'icomoon' !important;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: #543CE4;
        border: 1px solid #B7ABFF;
        position: absolute;
        bottom: 15px;
        left: 10px;
        z-index: 1;
      }

      .theme-preview:before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 40%;
        padding-top: 40%;
        transform: rotate(45deg) translate(0%, 70%);
        background: #7D6AED;
      }
    }

    .ribbon-premium {
      position: absolute;
      z-index: 1;
      top: 0;
      right: 0;
      width: 30%;
      height: 50%;
      background: url("../assets/img/ribbon-premium.svg") no-repeat top right;
      background-size: cover;
      pointer-events: none;
    }
  }

  img {
    width: 100%;
    display: block;
  }

  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border: solid 4px #7D6AED;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;
    border-radius: 12px;
    box-sizing: border-box;
  }
}

.theme-remove-btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  z-index: 1;
  top: 15px;
  right: 15px;
  cursor: pointer;
  border-radius: 50%;
  background: #543CE4;
  border: 1px solid #B7ABFF; 
  color: #fff;
  
  &:hover {
    background-color: #BEC1DA;
  }
  
  .icon-close {
    &:before {
      color: #fff;
    }
  }
}

</style>


